import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class CrowdfundingReportStatusError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('CrowdfundingReportStatusError', ...args);
    }
}
export default CrowdfundingReportStatusError;
